import { decorate, observable, action, computed } from 'mobx';
import BaseStore from '../../BaseStore';

class ShareStore extends BaseStore {
    isLoading = false
    isSharedUsersLoading = false

    activeUsers = [];
    roles = [];
    sharedUsers = [];
    inviteLinks = [];
    savingUserEmails = new Set();
    loadingRoles = new Set();

    constructor(appStore, packStore) {
        super(appStore);
        this.packStore = packStore;
        // this.fetchData();

        if (!this.pack || !this.pack.is_admin) {
            return;
        }
        this.fetchSharedUsers();
        this.fetchInviteLinks();
    }

    get pack() {
        return this.packStore?.pack ?? window.PACK;
    }


    handleClick = event => {
        this.reminders = [];
        this.fetchData(true);
        this.anchorEl = document.body;
        // this.anchorEl = event.currentTarget;
    };

    handleClose = () => {
        this.anchorEl = null;
    };

    fetchData = (forceUpdate = false) => {
        if (!this.pack || !this.pack.is_admin) {
            return;
        }
        this.fetchRoles(forceUpdate);
        this.fetchSharedUsers();
        this.fetchActiveUsers();
        this.fetchInviteLinks();
    }

    fetchActiveUsers(forceUpdate = false) {
        let me = this,
            response;

        if (me.activeUsers.length !== 0 && !forceUpdate) {
            return;
        }
        if (me.currentAjaxRequest) {
            me.currentAjaxRequest.cancelAjaxRequest();
        }

        me.isLoading = true;
        response = window.TL.ApiClient.Users.getActiveUsers({});

        me.currentAjaxRequest = response;
        response.then({
            success: function (response) {
                me.isLoading = false;

                if (response.success) {
                    me.activeUsers = response.data;
                } else {
                    Ext.Msg.alert('Error', response.message)
                }
            },
            failure: function (response) {
                me.isLoading = false;
                if (response.statusText == "transaction aborted") {
                    return;
                }
                Ext.Msg.alert('Error', 'Something went wrong. Please try again.')
            }
        });
    }

    fetchRoles(forceUpdate = false) {
        const me = this;

        if (me.roles.length !== 0 && !forceUpdate) {
            return;
        }

        window.TL.ApiClient.Roles.getRoles({
            pack_id: this.pack.id
        }).then({
            success: function (response) {
                if (!response.success) {
                    Ext.Msg.alert('Error', response.messages);
                    return;
                }
                me.roles = response.data;
            },
            failure: function () {
                console.log(arguments);
            }
        })
    }

    fetchSharedUsers(forceUpdate = false) {
        const me = this;

        if (me.sharedUsers.length !== 0 && !forceUpdate) {
            return;
        }

        me.isSharedUsersLoading = true;
        window.TL.ApiClient.Roles.getSharedUsers({
            pack_id: this.pack.id
        }).then({
            success: function (response) {
                me.isSharedUsersLoading = false;
                if (!response.success) {
                    Ext.Msg.alert('Error', response.messages);
                    return;
                }

                me.sharedUsers = response.data;
                me.fireOnChangeEvent();
            },
            failure: function () {
                me.isSharedUsersLoading = false;
                console.log(arguments);
            }
        })
    }

    fetchInviteLinks = async (forceUpdate = false) => {
        const me = this;

        if (me.inviteLinks.length != 0 && !forceUpdate) {
            return;
        }

        try {
            const resp = await window.TL.ApiClient.Invite.getAll(this.pack.id);
            me.inviteLinks = resp.data.data;
            me.fireOnChangeEvent();
        } catch (err) {
            console.log(err);
        }
    }

    handleDeleteUserRole = (user) => {
        const me = this;

        me.savingUserEmails.add(user.email);
        window.TL.ApiClient.Roles.deleteUserRole({
            role_id: user.role_id,
            email: user.email,
        }).then({
            success: function (response) {
                me.savingUserEmails.delete(user.email);
                if (!response.success) {
                    Ext.Msg.alert('Error', response.messages);
                    return;
                }

                const index = me.sharedUsers.findIndex(sharedUser => sharedUser.email == user.email);
                me.sharedUsers.splice(index, 1);
                Ext.Msg.alert('Success', "Deleted Successfully");
                me.fireOnChangeEvent();
            },
            failure: function () {
                console.log(arguments);
                me.savingUserEmails.delete(user.email);
            }
        })
    }


    handleUpdateUserRole = (user, newRole) => {
        const me = this;
        user.role_id = newRole.id

        me.savingUserEmails.add(user.email);
        window.TL.ApiClient.Roles.updateUserRole({
            role_id: newRole.id,
            email: user.email,
        }).then({
            success: function (response) {
                me.savingUserEmails.delete(user.email);
                if (!response.success) {
                    Ext.Msg.alert('Error', response.messages);
                    return;
                }
                Ext.Msg.alert('Success', "Updated Successfully");
            },
            failure: function () {
                console.log(arguments);
                me.savingUserEmails.delete(user.email);
            }
        })
    }

    handleAddUsersToRole = (values, cb) => {
        const me = this,
            role_id = values.role_id,
            emails = JSON.stringify(values.emails);

        window.TL.ApiClient.Roles.addUsersToRole({
            role_id: role_id,
            emails: emails,
        }).then({
            success: function (response) {
                if (!response.success) {
                    cb(true);
                    Ext.Msg.alert('Error', response.messages);
                    return;
                }
                cb();
                me.fetchSharedUsers(true);
                // Ext.Msg.alert('Success', "Users added successfully");
            },
            failure: function () {
                cb(true);
                console.log(arguments);
            }
        })

    }

    handleSaveInvite = async (values) => {
        const me = this,
            isDeleted = values.is_deleted == "1",
            successText = (!isDeleted ? (values.id ? "updated" : "created") : "deleted");

        try {
            const inviteData = await window.TL.ApiClient.Invite.saveInvite({
                ...values
            });
            Ext.Msg.alert("Success", 'Invite ' + successText + ' successfully.');

            if (!values.id) {
                me.inviteLinks.push(inviteData.data.data)
                this.fireOnChangeEvent();
                return;
            }

            const index = me.inviteLinks.findIndex(invite => values.id == invite.id);

            if (isDeleted) {
                me.inviteLinks.splice(index, 1);
            } else {
                me.inviteLinks[index] = { ...me.inviteLinks[index], ...values };
            }
            this.fireOnChangeEvent();
        } catch (e) {
            Ext.Msg.alert("Error", e.message);
            console.log(e);
        }
    }

    handleCreateRole = async (roleData, roleId) => {
        const me = this;

        return await new Promise((resolve, reject) => {
            const api = window.TL.ApiClient.Roles.createRole({
                ...roleData,
                pack_id: window.PACK.id,
                role_id: roleId
            });

            api.then({
                success: function (response) {
                    if (!response.success) {
                        resolve(false);
                        Ext.Msg.alert('Error', response.messages);
                        return;
                    }
                    if (!roleId) {
                        me.roles.push(response.data);
                    } else {
                        const roleIndex = me.roles.findIndex(role => role.id === roleId);
                        me.roles[roleIndex] = { ...me.roles[roleIndex], ...roleData };
                    }
                    resolve(true);
                },
                failure: function () {
                    console.log(arguments);
                    resolve(false);
                }
            })
        });
    }

    handleDeleteRole = (role) => {
        const me = this;

        Ext.Msg.confirm('Alert', '<div style="color: red">Deleting a role will unshare all the users in that role</div> Are you sure? Do you want to delete the role ' + role.name + '?', (button) => {
            if (button === 'yes') {
                me.loadingRoles.add(role.id);
                window.TL.ApiClient.Roles.deleteRole({
                    role_id: role.id,
                }).then({
                    success: (response) => {
                        me.loadingRoles.delete(role.id);
                        if (!response.success) {
                            console.log(response);
                            Ext.Msg.alert('Error', response.messages);
                            return;
                        }

                        const index = me.roles.findIndex(item => item.id == role.id);
                        me.roles.splice(index, 1);
                        Ext.Msg.alert('Success', "Deleted Successfully");
                        this.fetchSharedUsers(true);
                    },
                    failure: function () {
                        console.log(arguments);
                        me.loadingRoles.delete(role.id);
                    }
                })
            }
        });
    }

    fireOnChangeEvent = () => {
        const me = this;

        me.listeners?.onChange({
            sharedUsers: me.sharedUsers,
            inviteLinks: me.inviteLinks
        })
    }

    get isShared() {
        return this.inviteLinks.length > 0 || this.sharedUsers.length > 1
    }

}

decorate(ShareStore, {
    anchorEl: observable,
    isLoading: observable,
    isSharedUsersLoading: observable,

    activeUsers: observable,
    roles: observable,
    sharedUsers: observable,
    inviteLinks: observable,
    savingUserEmails: observable,
    loadingRoles: observable,
});

export default ShareStore;